import { Quill } from "react-quill"
import { styled } from "@mui/material"
import { renderToString } from "react-dom/server"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faBold,
  faItalic,
  faUnderline,
  faTextSlash,
  faListOl,
  faListUl,
  faOutdent,
  faIndent,
  faScissors,
  faCopy,
  faPaste,
  faOmega,
  faUndo,
  faRedo
} from "@fortawesome/pro-solid-svg-icons"
import { FC } from "react"

const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize
}))

const icons = Quill.import("ui/icons")
icons["bold"] = renderToString(<Icon icon={faBold} />)
icons["italic"] = renderToString(<Icon icon={faItalic} />)
icons["underline"] = renderToString(<Icon icon={faUnderline} />)
icons["clean"] = renderToString(<Icon icon={faTextSlash} />)
icons["list"].bullet = renderToString(<Icon icon={faListUl} />)
icons["list"].ordered = renderToString(<Icon icon={faListOl} />)
icons["indent"]["+1"] = renderToString(<Icon icon={faIndent} />)
icons["indent"]["-1"] = renderToString(<Icon icon={faOutdent} />)
icons["redo"] = renderToString(<Icon icon={faRedo} />)
icons["undo"] = renderToString(<Icon icon={faUndo} />)
icons["cut"] = renderToString(<Icon icon={faScissors} />)
icons["copy"] = renderToString(<Icon icon={faCopy} />)
icons["paste"] = renderToString(<Icon icon={faPaste} />)
icons["formula"] = renderToString(<Icon icon={faOmega} />)

interface CustomEditorToolbarProps {
  disabled?: boolean
  handleOpenCharactersModal: () => void
}

export const CustomEditorToolbar: FC<CustomEditorToolbarProps> = ({
  disabled,
  handleOpenCharactersModal
}) => (
  <div
    id="toolbar"
    role="toolbar"
    aria-label="Formatting controls"
    tabIndex={0}
  >
    <span className="ql-formats">
      <button disabled={disabled} className="ql-bold" aria-label="Bold" />
      <button disabled={disabled} className="ql-italic" aria-label="Italic" />
      <button
        disabled={disabled}
        className="ql-underline"
        aria-label="Underline"
      />
      <button
        disabled={disabled}
        className="ql-clean"
        aria-label="Clean All Formatting"
      />
    </span>
    <span className="ql-formats">
      <button
        disabled={disabled}
        className="ql-list"
        value="ordered"
        aria-label="Ordered list"
      />
      <button
        disabled={disabled}
        className="ql-list"
        value="bullet"
        aria-label="Bullet list"
      />
      <button
        disabled={disabled}
        className="ql-indent"
        value="+1"
        aria-label="Indent"
      />
      <button
        disabled={disabled}
        className="ql-indent"
        value="-1"
        aria-label="Outdent"
      />
    </span>
    <span className="ql-formats">
      <button disabled={disabled} className="ql-cut" aria-label="Cut" />
      <button disabled={disabled} className="ql-copy" aria-label="Copy" />
      <button disabled={disabled} className="ql-paste" aria-label="Paste" />
      <button disabled={disabled} className="ql-undo" aria-label="Undo" />
      <button disabled={disabled} className="ql-redo" aria-label="Redo" />
    </span>
    <span className="ql-formats">
      <button
        disabled={disabled}
        className="ql-formula"
        aria-label="Formula"
        onClick={handleOpenCharactersModal}
      />
    </span>
  </div>
)
